// extracted by mini-css-extract-plugin
export default {"imgdiv":"_35ce58a483 df25244b4f","img":"c08e72a5bc _1d72715ba8"};